import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=465b6aeb&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=465b6aeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465b6aeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('465b6aeb')) {
      api.createRecord('465b6aeb', component.options)
    } else {
      api.reload('465b6aeb', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=465b6aeb&scoped=true&", function () {
      api.rerender('465b6aeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lK1yRvwVK7PU/JS/comp/DocBox.vue"
export default component.exports